export enum ORDER_STATE {
  EXISTING_ORDER = 'EXISTING_ORDER',
  NEW_ORDER = 'NEW_ORDER',
  ADD_PRODUCT = 'ADD_PRODUCT',
}

export enum CLIENT_STATE {
  EXISTING = 'EXISTING',
  NEW = 'NEW',
}
